import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { portalApi } from '@/lib/api/portal.js';
import { parseApiError } from '@/lib/api/errors.js';
import { toastError, toastSuccess } from '@/lib/toast.js';

export function PortalNewTicketPage() {
  const navigate = useNavigate();
  const [deviceMake, setDeviceMake] = useState('Apple');
  const [deviceModel, setDeviceModel] = useState('');
  const [issueDescription, setIssueDescription] = useState('');
  const [preferredDate, setPreferredDate] = useState('');
  const [additionalNotes, setAdditionalNotes] = useState('');

  const mutation = useMutation({
    mutationFn: () =>
      portalApi.createTicket({
        deviceMake,
        deviceModel,
        issueDescription,
        preferredDate: preferredDate ? new Date(preferredDate).toISOString() : undefined,
        additionalNotes: additionalNotes || undefined,
      }),
    onSuccess: () => {
      toastSuccess("Request submitted! We'll be in touch to confirm your appointment.");
      navigate('/portal/dashboard');
    },
    onError: (err) => {
      const parsed = parseApiError(err);
      toastError(parsed.message, parsed.code);
    },
  });

  return (
    <div className="mx-auto max-w-lg space-y-5">
      <Link to="/portal/dashboard" className="text-sm font-semibold text-slate-500">
        ← Back
      </Link>
      <h1 className="text-2xl font-bold">New Repair Request</h1>
      <form
        className="space-y-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
      >
        <label className="block text-sm font-medium">
          Device Make
          <select
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={deviceMake}
            onChange={(e) => setDeviceMake(e.target.value)}
          >
            {['Apple', 'Samsung', 'Google', 'Motorola', 'Other'].map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-sm font-medium">
          Device Model
          <input
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={deviceModel}
            onChange={(e) => setDeviceModel(e.target.value)}
            placeholder="iPhone 14 Pro"
            required
          />
        </label>
        <label className="block text-sm font-medium">
          Issue
          <textarea
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            rows={4}
            value={issueDescription}
            onChange={(e) => setIssueDescription(e.target.value)}
            required
          />
        </label>
        <label className="block text-sm font-medium">
          Preferred Drop-off Date
          <input
            type="date"
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={preferredDate}
            onChange={(e) => setPreferredDate(e.target.value)}
          />
        </label>
        <label className="block text-sm font-medium">
          Additional Notes
          <textarea
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            rows={2}
            value={additionalNotes}
            onChange={(e) => setAdditionalNotes(e.target.value)}
          />
        </label>
        <button
          type="submit"
          disabled={mutation.isPending}
          className="w-full rounded-xl bg-[#1B4F8A] px-4 py-3 text-sm font-semibold text-white disabled:opacity-50"
        >
          Submit Repair Request
        </button>
      </form>
    </div>
  );
}
